import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { StatusEnum } from "../../../../../commons/enums/status-enum";
import { EnsueCollection } from "../../../../../ensue-react-system/utilities/ensue-collection";
import { footballTeamService } from "../../../../../commons";
import { FootballAssociatedCompetition } from "../../../../../commons/models/football/football-associated-competition";

export interface IFootballTeamCompetitionsState {
  teamCompetitionList: EnsueCollection<FootballAssociatedCompetition>;
  teamCompetitionListStatus: StatusEnum;
}

const initialState: IFootballTeamCompetitionsState = {
  teamCompetitionList: new EnsueCollection<FootballAssociatedCompetition>(),
  teamCompetitionListStatus: StatusEnum.Idle,
};

export const fetchTeamCompetitionList = createAsyncThunk(
  "teams/fetchTeamCompetitionList",
  async (teamId: number, thunkAPI) => {
    try {
      const teamCompetitionList = await footballTeamService.getTeamCompetitions(teamId);
      return teamCompetitionList;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

const footballTeamCompetitionListSlice = createSlice({
  name: "footballTeamCompetitionList",
  initialState: initialState,
  reducers: {
    cleanUpTeamCompetitions(state) {
      state.teamCompetitionList = new EnsueCollection<FootballAssociatedCompetition>();
      state.teamCompetitionListStatus = StatusEnum.Idle;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchTeamCompetitionList.pending, (state) => {
        state.teamCompetitionListStatus = StatusEnum.Loading;
      })
      .addCase(
        fetchTeamCompetitionList.fulfilled,
        (state, action: PayloadAction<EnsueCollection<FootballAssociatedCompetition>>) => {
          state.teamCompetitionListStatus = StatusEnum.Succeeded;
          state.teamCompetitionList = action.payload;
        }
      )
      .addCase(fetchTeamCompetitionList.rejected, (state) => {
        state.teamCompetitionListStatus = StatusEnum.Failed;
      });
  },
});

export const { cleanUpTeamCompetitions } = footballTeamCompetitionListSlice.actions;
export default footballTeamCompetitionListSlice.reducer;
